/**
 * Map usage tracking.
 *
 * Pushes events onto the Google Tag Manager data layer. The GTM container is
 * embedded in the theme's html.html.twig, so dataLayer already exists by the
 * time these fire.
 */
(function () {
  window.EearthMapTracking = {

    /**
     * Pushes an event onto the GTM data layer.
     *
     * @param {string} name
     *   The event name, e.g. 'map_filter'.
     * @param {object} params
     *   (optional) Extra parameters to send alongside the map filters.
     */
    event: function (name, params) {
      const settings = window.drupalSettings && window.drupalSettings.eearthMap;
      const user = window.drupalSettings && window.drupalSettings.user;

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({
        event: name,
        // Every filter active at the time, not just the one that changed.
        map_filters: window.location.search.replace(/^\?/, ''),
        // The country is in the path rather than the query string.
        map_country: (settings && settings.countryCode) || '',
        // Whether, not who. Never the uid.
        map_logged_in: !!(user && user.uid)
      }, params || {}));
    }

  };
})();
